<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import InformeRespuestas from "./informe_respuestas.vue";

const api = "/api/escaneos-respuestas";

export default {
    components: { Layout, PageHeader, InformeRespuestas },
    data() {
        return {
            title: "Escanear respuestas", modo: "hojas",
            items: [{ text: "Digitalizador" }, { text: "Escanear respuestas", active: true }],
            registros: [], perfil: { disponible: false }, seleccionado: null,
            archivo: null, nombre: "", previa: "", progreso: 0,
            cargando: true, guardando: false, procesando: false, cargandoDetalle: false,
            cargandoComparacion: false, error: "", busqueda: "", filtro: "",
            leyendoAzure: false, autorizarAzure: false, soloMarcadas: false, soloDudosas: false,
            mostrarMarcasAzure: false, deteccionAzure: null,
            tab: "respuestas", puntos: [], dimensiones: [1, 1],
            compararId: "", comparacion: null, soloDiferencias: false,
            solicitudDetalle: 0, solicitudComparacion: 0,
            rutProveedor: "", confirmarProveedor: false, asociandoProveedor: false,
        };
    },
    computed: {
        ocupada() { return this.guardando || this.procesando || this.leyendoAzure || this.asociandoProveedor; },
        azureDisponible() { return !!(this.perfil.azure && this.perfil.azure.disponible); },
        resultadoAzure() { return this.seleccionado && this.seleccionado.azure; },
        respuestasNumeradasAzure() {
            return this.resultadoAzure && Array.isArray(this.resultadoAzure.respuestas_numeradas) ? this.resultadoAzure.respuestas_numeradas : [];
        },
        comparacionPautaAzure() { return this.resultadoAzure && this.resultadoAzure.comparacion_pauta; },
        comparacionProveedor() { return this.seleccionado && this.seleccionado.comparacion_proveedor; },
        alumnosProveedor() {
            if (!this.seleccionado) return [];
            const normalizar = rut => rut.replace(/[\s.\-]/g, "").toUpperCase();
            const usados = new Set(this.registros.filter(r => r.id !== this.seleccionado.id &&
                r.proveedor_sha256 === this.seleccionado.proveedor_sha256 && r.comparacion_proveedor && r.comparacion_proveedor.alumno)
                .map(r => normalizar(r.comparacion_proveedor.alumno.rut)));
            return (this.seleccionado.proveedor_alumnos || []).filter(a => !usados.has(normalizar(a.rut)))
                .sort((a, b) => normalizar(a.rut).slice(0, -1).localeCompare(normalizar(b.rut).slice(0, -1), "es", { numeric: true }));
        },
        respuestasProveedor() {
            return Object.fromEntries(((this.comparacionProveedor && this.comparacionProveedor.respuestas) || [])
                .map(respuesta => [respuesta.pregunta, respuesta]));
        },
        limitePreguntasAzure() {
            const pauta = this.comparacionPautaAzure;
            return pauta && ["comparada", "comparada_referencial"].includes(pauta.estado) &&
                Number.isInteger(pauta.cantidad_preguntas) && pauta.cantidad_preguntas > 0 && pauta.cantidad_preguntas <= 80
                ? pauta.cantidad_preguntas : 80;
        },
        respuestasVisiblesAzure() {
            return this.respuestasNumeradasAzure.filter(respuesta => respuesta.pregunta <= this.limitePreguntasAzure);
        },
        bloquesRespuestasAzure() {
            return [1, 21, 41, 61].filter(inicio => inicio <= this.limitePreguntasAzure).map(inicio => ({
                inicio, fin: Math.min(inicio + 19, this.limitePreguntasAzure),
                respuestas: this.respuestasVisiblesAzure.filter(respuesta => respuesta.pregunta >= inicio && respuesta.pregunta < inicio + 20),
            }));
        },
        letrasDetectadasAzure() { return this.respuestasVisiblesAzure.filter(respuesta => respuesta.estado === "detectada").length; },
        puedeLeerAzure() {
            return !!(this.seleccionado && this.azureDisponible && this.autorizarAzure && !this.ocupada && !this.resultadoAzure &&
                this.seleccionado.estado_azure !== "procesando");
        },
        puedeReleerAzure() {
            return !!(this.seleccionado && this.resultadoAzure && this.azureDisponible && this.autorizarAzure && !this.ocupada);
        },
        deteccionesAzure() {
            return this.resultadoAzure ? this.resultadoAzure.marcas.map((marca, index) => ({ ...marca, deteccion: index + 1 })) : [];
        },
        marcasAzure() {
            return this.deteccionesAzure.filter(marca => (!this.soloMarcadas || marca.estado === "selected") &&
                (!this.soloDudosas || !Number.isFinite(marca.confianza) || marca.confianza < 0.8));
        },
        resumenAzure() {
            return this.deteccionesAzure.reduce((totales, marca) => {
                if (marca.estado === "selected") totales.seleccionadas++;
                if (!Number.isFinite(marca.confianza) || marca.confianza < 0.8) totales.dudosas++;
                return totales;
            }, { seleccionadas: 0, dudosas: 0 });
        },
        paginaAzure() {
            const raw = this.resultadoAzure && this.resultadoAzure.raw_response;
            const pages = raw && raw.analyzeResult && raw.analyzeResult.pages;
            return Array.isArray(pages) ? pages.find(pagina => pagina.pageNumber === 1 && pagina.unit === "pixel") : null;
        },
        camposEscritosAzure() {
            const datos = (this.resultadoAzure && this.resultadoAzure.datos_escritos) || {};
            const rutVerificacion = this.resultadoAzure && this.resultadoAzure.rut_verificacion;
            return Object.entries({ nombre_completo: "Nombre completo", rut: "RUT (burbujas)", colegio: "Colegio",
                correo: "Correo", telefono: "Telefono", asignatura: "Asignatura", curso: "Curso" }).map(([id, etiqueta]) => {
                const valor = id === "rut" ? ((rutVerificacion && (rutVerificacion.valor_rut || rutVerificacion.valor_tentativo)) || null)
                    : (typeof datos[id] === "string" ? datos[id] : null);
                return { id, etiqueta, valor, escrito: id === "rut" ? datos.rut : null,
                    rutVerificacion: id === "rut" ? rutVerificacion : null };
            });
        },
        marcasPosicionadasAzure() {
            return this.marcasAzure.map(marca => ({ ...marca, posicion: this.posicionAzure(marca) })).filter(marca => marca.posicion);
        },
        marcaActivaAzure() {
            return this.marcasPosicionadasAzure.find(marca => marca.deteccion === this.deteccionAzure) || null;
        },
        recorteAzure() {
            if (!this.marcaActivaAzure) return null;
            const puntos = this.marcaActivaAzure.poligono;
            const horizontales = puntos.filter((valor, index) => index % 2 === 0);
            const verticales = puntos.filter((valor, index) => index % 2 === 1);
            const izquierda = Math.max(0, Math.min(...horizontales) - 35);
            const arriba = Math.max(0, Math.min(...verticales) - 20);
            const ancho = Math.min(this.paginaAzure.width, Math.max(...horizontales) + 35) - izquierda;
            const alto = Math.min(this.paginaAzure.height, Math.max(...verticales) + 20) - arriba;
            return `${izquierda} ${arriba} ${ancho} ${alto}`;
        },
        filtrados() {
            const terminos = this.normalizarBusqueda(this.busqueda).split(/\s+/).filter(Boolean);
            return this.registros.filter(registro => {
                const lectura = registro.resumen_lectura || {};
                const texto = this.normalizarBusqueda([registro.nombre, registro.archivo_original, lectura.rut, lectura.rut_tentativo,
                    lectura.nombre_completo, lectura.asignatura, lectura.tipo_prueba, lectura.nombre_pauta].join(" "));
                const rut = this.normalizarBusqueda(lectura.rut || lectura.rut_tentativo || "").replace(/[^a-z0-9]/g, "");
                return (!this.filtro || this.estadoRegistro(registro) === this.filtro) &&
                    terminos.every(termino => texto.includes(termino) ||
                        (/^[\d.k-]+$/.test(termino) && rut.includes(termino.replace(/[.-]/g, ""))));
            });
        },
        resultado() { return this.seleccionado && this.seleccionado.resultado; },
        respuestas() { return this.resultado ? this.resultado.respuestas : []; },
        resumen() {
            return this.respuestas.reduce((totales, respuesta) => {
                totales[respuesta.estado] = (totales[respuesta.estado] || 0) + 1;
                return totales;
            }, {});
        },
        campos() { return this.resultado && this.resultado.fields ? this.resultado.fields : {}; },
        candidatos() {
            return this.registros.filter(registro => this.seleccionado && registro.id !== this.seleccionado.id &&
                registro.estado === "piloto_pendiente_revision");
        },
        compatibles() {
            const primera = this.resultado;
            const segunda = this.comparacion && this.comparacion.resultado;
            return !!(primera && segunda && primera.estado === "piloto_pendiente_revision" && segunda.estado === "piloto_pendiente_revision" &&
                primera.template_sha256 && primera.template_sha256 === segunda.template_sha256 &&
                primera.template_id === segunda.template_id && primera.template_version === segunda.template_version);
        },
        comparadas() {
            if (!this.compatibles) return [];
            const otras = new Map(this.comparacion.resultado.respuestas.map(respuesta => [respuesta.pregunta, respuesta]));
            return this.respuestas.map(respuesta => {
                const otra = otras.get(respuesta.pregunta);
                const legibles = respuesta.estado === "valida" && otra && otra.estado === "valida";
                return { pregunta: respuesta.pregunta, actual: respuesta.alternativa, otra: otra ? otra.alternativa : null,
                    estado: !legibles ? "sin_lectura" : respuesta.alternativa === otra.alternativa ? "coincide" : "difiere" };
            });
        },
        comparadasVisibles() { return this.comparadas.filter(fila => !this.soloDiferencias || fila.estado !== "coincide"); },
        resumenComparacion() {
            return this.comparadas.reduce((totales, fila) => { totales[fila.estado]++; return totales; }, { coincide: 0, difiere: 0, sin_lectura: 0 });
        },
        json() { return this.seleccionado ? JSON.stringify(this.seleccionado, null, 2) : ""; },
        puedeProcesar() { return this.perfil.disponible && !this.resultado && this.puntos.length === this.perfil.puntos.length && !this.ocupada; },
        imagenUrl() { return this.seleccionado ? `${api}/${this.seleccionado.id}/imagen` : this.previa; },
    },
    created() { this.cargar(); },
    beforeDestroy() { if (this.previa) URL.revokeObjectURL(this.previa); },
    methods: {
        mensaje(error) {
            const data = error.response && error.response.data;
            if (data && data.errors) return Object.values(data.errors).flat().join(" ");
            return data && (data.mensaje || data.message) || "No se pudo completar la solicitud. Intenta nuevamente.";
        },
        async cargar() {
            this.cargando = true;
            this.error = "";
            try {
                const [historial, perfil] = await Promise.all([axios.get(api), axios.get(`${api}/perfil`)]);
                this.registros = historial.data.registros;
                this.perfil = perfil.data;
            } catch (error) { this.error = this.mensaje(error); }
            finally { this.cargando = false; }
        },
        elegirArchivo(event) {
            const archivo = event.target.files[0];
            this.error = "";
            if (this.previa) URL.revokeObjectURL(this.previa);
            this.previa = "";
            this.archivo = null;
            if (!archivo) return;
            if (!["image/jpeg", "image/png"].includes(archivo.type) || archivo.size > 15 * 1024 * 1024) {
                this.error = "Selecciona una imagen JPG o PNG de hasta 15 MB.";
                event.target.value = "";
                return;
            }
            this.solicitudDetalle++;
            this.solicitudComparacion++;
            this.cargandoDetalle = false;
            this.cargandoComparacion = false;
            this.seleccionado = null;
            this.comparacion = null;
            this.compararId = "";
            this.tab = "respuestas";
            this.archivo = archivo;
            this.deteccionAzure = null;
            this.previa = URL.createObjectURL(archivo);
            this.puntos = [];
            this.autorizarAzure = false;
        },
        async subir() {
            if (!this.archivo || this.ocupada) return;
            this.guardando = true;
            this.error = "";
            this.progreso = 0;
            const datos = new FormData();
            datos.append("imagen", this.archivo);
            datos.append("nombre", this.nombre.trim());
            try {
                const response = await axios.post(api, datos, { onUploadProgress: evento => {
                    if (evento.total) this.progreso = Math.round(evento.loaded * 100 / evento.total);
                } });
                this.actualizarRegistro(response.data);
                this.seleccionado = response.data;
                this.tab = this.azureDisponible ? "azure" : this.perfil.disponible ? "alineacion" : "respuestas";
                this.archivo = null;
                this.nombre = "";
                this.$refs.archivo.value = "";
                if (this.previa) URL.revokeObjectURL(this.previa);
                this.previa = "";
            } catch (error) { this.error = this.mensaje(error); }
            finally { this.guardando = false; }
        },
        actualizarRegistro(registro) {
            const resumen = Object.assign({}, registro);
            delete resumen.resultado;
            delete resumen.azure;
            delete resumen.azure_historial;
            delete resumen.proveedor_alumnos;
            const index = this.registros.findIndex(item => item.id === registro.id);
            if (index < 0) this.registros.unshift(resumen);
            else this.$set(this.registros, index, resumen);
        },
        async abrir(registro) {
            if (this.ocupada) return;
            const solicitud = ++this.solicitudDetalle;
            this.solicitudComparacion++;
            this.cargandoDetalle = true;
            this.cargandoComparacion = false;
            this.seleccionado = null;
            this.comparacion = null;
            this.compararId = "";
            this.puntos = [];
            this.autorizarAzure = false;
            this.error = "";
            this.tab = "respuestas";
            this.deteccionAzure = null;
            this.rutProveedor = "";
            this.confirmarProveedor = false;
            try {
                const response = await axios.get(`${api}/${registro.id}`);
                if (solicitud === this.solicitudDetalle) {
                    this.seleccionado = response.data;
                    this.rutProveedor = response.data.proveedor_asociacion ? response.data.proveedor_asociacion.rut : "";
                    this.tab = response.data.azure || (!response.data.resultado && this.azureDisponible) ? "azure" : "respuestas";
                }
            } catch (error) { if (solicitud === this.solicitudDetalle) this.error = this.mensaje(error); }
            finally { if (solicitud === this.solicitudDetalle) this.cargandoDetalle = false; }
        },
        async abrirDesdeInforme(hoja) {
            this.modo = "hojas";
            await this.abrir(hoja);
        },
        async asociarProveedor() {
            if (!this.seleccionado || !this.rutProveedor || !this.confirmarProveedor || this.ocupada) return;
            this.asociandoProveedor = true;
            this.error = "";
            try {
                const response = await axios.post(`${api}/${this.seleccionado.id}/asociar-proveedor`, {
                    rut: this.rutProveedor, confirmar_identidad: true,
                });
                this.seleccionado = response.data;
                this.actualizarRegistro(response.data);
                this.confirmarProveedor = false;
            } catch (error) { this.error = this.mensaje(error); }
            finally { this.asociandoProveedor = false; }
        },
        agregarPunto(event) {
            if (this.tab !== "alineacion" || !this.perfil.disponible || this.ocupada || this.resultado || this.puntos.length >= this.perfil.puntos.length) return;
            const bounds = event.currentTarget.getBoundingClientRect();
            this.puntos.push([Math.round((event.clientX - bounds.left) / bounds.width * this.dimensiones[0]),
                Math.round((event.clientY - bounds.top) / bounds.height * this.dimensiones[1])]);
        },
        posicion(punto, tamano) { return { left: `${punto[0] / tamano[0] * 100}%`, top: `${punto[1] / tamano[1] * 100}%` }; },
        posicionAzure(marca) {
            const pagina = this.paginaAzure;
            const puntos = marca.poligono;
            if (!pagina || marca.pagina !== pagina.pageNumber || !Number.isFinite(pagina.width) || pagina.width <= 0 ||
                !Number.isFinite(pagina.height) || pagina.height <= 0 || !Array.isArray(puntos) || puntos.length < 6 || puntos.length % 2 ||
                puntos.some((valor, index) => !Number.isFinite(valor) || valor < 0 || valor > (index % 2 === 0 ? pagina.width : pagina.height))) return null;
            const horizontales = puntos.filter((valor, index) => index % 2 === 0);
            const verticales = puntos.filter((valor, index) => index % 2 === 1);
            const izquierda = Math.min(...horizontales);
            const arriba = Math.min(...verticales);
            const ancho = Math.max(...horizontales) - izquierda;
            const alto = Math.max(...verticales) - arriba;
            if (!ancho || !alto) return null;
            return { left: `${izquierda / pagina.width * 100}%`, top: `${arriba / pagina.height * 100}%`,
                width: `${ancho / pagina.width * 100}%`, height: `${alto / pagina.height * 100}%` };
        },
        enfocarMarcaAzure(marca) {
            this.deteccionAzure = marca.deteccion;
            this.mostrarMarcasAzure = true;
        },
        enfocarRespuestaAzure(respuesta) {
            const candidatas = this.deteccionesAzure.filter(marca => respuesta.detecciones.includes(marca.deteccion));
            const marca = candidatas.find(marca => marca.estado === "selected") || candidatas[0];
            if (!marca) return;
            this.soloMarcadas = false;
            this.soloDudosas = false;
            this.enfocarMarcaAzure(marca);
            this.$nextTick(() => {
                if (this.$refs.detalleMarcaAzure) this.$refs.detalleMarcaAzure.scrollIntoView({ block: "center", behavior: "smooth" });
            });
        },
        async leerAzure() {
            if (!this.puedeLeerAzure) return;
            this.leyendoAzure = true;
            this.error = "";
            const id = this.seleccionado.id;
            try {
                const response = await axios.post(`${api}/${id}/azure`, { autorizar_azure: true }, { timeout: 195000 });
                this.seleccionado = response.data;
                this.actualizarRegistro(response.data);
            } catch (error) {
                this.error = this.mensaje(error);
                try {
                    const response = await axios.get(`${api}/${id}`);
                    this.seleccionado = response.data;
                    this.actualizarRegistro(response.data);
                } catch (_) { this.error += " No fue posible actualizar el registro."; }
            } finally {
                this.leyendoAzure = false;
                this.autorizarAzure = false;
            }
        },
        async releerAzure() {
            if (!this.puedeReleerAzure) return;
            this.leyendoAzure = true;
            this.error = "";
            const id = this.seleccionado.id;
            const clave = crypto.randomUUID();
            try {
                const response = await axios.post(`${api}/${id}/azure`, {
                    autorizar_azure: true, releer_azure: true, clave_relectura: clave,
                }, { timeout: 195000 });
                this.seleccionado = response.data;
                this.actualizarRegistro(response.data);
            } catch (error) {
                this.error = this.mensaje(error);
                try {
                    const response = await axios.get(`${api}/${id}`);
                    this.seleccionado = response.data;
                    this.actualizarRegistro(response.data);
                } catch (_) { this.error += " No fue posible actualizar el registro."; }
            } finally {
                this.leyendoAzure = false;
                this.autorizarAzure = false;
            }
        },
        async procesar() {
            if (!this.puedeProcesar) return;
            this.procesando = true;
            this.error = "";
            const id = this.seleccionado.id;
            try {
                const response = await axios.post(`${api}/${id}/procesar`, { puntos: this.puntos, plantilla_sha256: this.perfil.sha256 }, { timeout: 110000 });
                this.seleccionado = response.data;
                this.actualizarRegistro(response.data);
                this.tab = "respuestas";
            } catch (error) {
                this.error = this.mensaje(error);
                try {
                    const response = await axios.get(`${api}/${id}`);
                    this.seleccionado = response.data;
                    this.actualizarRegistro(response.data);
                } catch (_) { this.error += " No fue posible actualizar el registro."; }
            } finally { this.procesando = false; }
        },
        async comparar() {
            const solicitud = ++this.solicitudComparacion;
            this.comparacion = null;
            this.error = "";
            this.cargandoComparacion = !!this.compararId;
            if (!this.compararId) return;
            try {
                const response = await axios.get(`${api}/${this.compararId}`);
                if (solicitud === this.solicitudComparacion) this.comparacion = response.data;
            } catch (error) { if (solicitud === this.solicitudComparacion) this.error = this.mensaje(error); }
            finally { if (solicitud === this.solicitudComparacion) this.cargandoComparacion = false; }
        },
        estado(value) {
            return { pendiente_calibracion: "Pendiente de lectura", pendiente_alineacion: "Pendiente de alineacion", piloto_pendiente_revision: "Pendiente de revision",
                procesando: "Leyendo", completado_pendiente_revision: "Lectura pendiente de revision",
                rechazada_calidad: "Calidad insuficiente", error: "Error de lectura", valida: "Aceptada", ambigua: "Ambigua", en_blanco: "En blanco", ilegible: "Ilegible",
                coincide: "Coincide", difiere: "Difiere", sin_lectura: "Sin lectura segura", detectada: "Detectada, pendiente de revision" }[value] || value;
        },
        estadoRegistro(registro) {
            if (["procesando", "error"].includes(registro.estado_azure)) return registro.estado_azure;
            if (registro.resumen_lectura) return registro.resumen_lectura.estado;
            return registro.estado;
        },
        etiquetaEstadoRegistro(registro) {
            const lectura = registro.resumen_lectura;
            const estado = this.estadoRegistro(registro);
            if (estado === "comparada") return lectura.referencial ? "Lectura comparada · referencial" : "Lectura comparada";
            if (estado === "leida") return "Lectura guardada · sin pauta compatible";
            return this.estado(estado);
        },
        normalizarBusqueda(value) {
            return value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
        porcentaje(value) {
            return value.toLocaleString("es-CL", { maximumFractionDigits: 1 }) + "%";
        },
        motivo(value) {
            return { marca_multiple: "Doble marca", sin_marca: "Sin marca", lectura_inestable: "Marca tenue o inestable", marca_no_inequivoca: "Marca no inequivoca",
                grilla_no_identificada: "Numeros o encabezado A-E sin lectura segura", sin_marca_segura: "Azure no detecto una seleccion segura",
                marca_multiple_o_duplicada: "Varias marcas; requiere revision", marca_baja_confianza: "Marca con confianza inferior al 80%",
                alineacion_no_verificada: "Alineacion no verificada", imagen_desenfocada: "Imagen desenfocada", region_recortada: "Region recortada" }[value] || value || "";
        },
        fecha(value) { return new Date(value).toLocaleString("es-CL"); },
        confianzaAzure(value) { return Number.isFinite(value) ? `${Math.round(value * 100)}%` : "Sin dato"; },
        estadoRutAzure(value) {
            return { coincide: "Coincide con el manuscrito", difiere: "Difiere del manuscrito; se priorizan las burbujas",
                leido_burbujas: "Leído por burbujas; manuscrito sin lectura segura", pendiente_revision: "Requiere revisión" }[value] || "Sin verificación";
        },
        motivoRutAzure(value) {
            return { grilla_cedula_no_identificada: "Grilla de cédula no identificada",
                columna_incompleta: "Faltan detecciones en una columna", marca_multiple_o_duplicada: "Doble marca o detección duplicada",
                marca_baja_confianza: "Marca dudosa o con confianza inferior al 80%", sin_marca_segura: "Columna sin marcar",
                marca_fuera_de_grilla: "Marca fuera de las filas permitidas", rut_marcado_incompleto: "RUT marcado incompleto",
                verificador_sin_lectura_segura: "Dígito verificador sin lectura segura",
                digito_verificador_invalido: "El dígito verificador marcado no corresponde al número" }[value] || "";
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <section class="escaner">
            <nav class="nav nav-pills mb-3" aria-label="Vista del escáner">
                <button class="nav-link btn" :class="{ active: modo === 'hojas' }" :disabled="ocupada" @click="modo = 'hojas'">Hojas de respuestas</button>
                <button class="nav-link btn" :class="{ active: modo === 'informe' }" :disabled="ocupada" @click="modo = 'informe'">Informe comparativo</button>
            </nav>
            <InformeRespuestas v-if="modo === 'informe'" @revisar="abrirDesdeInforme" />
            <div v-else>
            <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
            <form class="carga" @submit.prevent="subir">
                <div class="campo-archivo">
                    <label for="hoja-respuestas">Hoja de respuestas <span class="text-muted">JPG / PNG · 15 MB max.</span></label>
                    <input id="hoja-respuestas" ref="archivo" type="file" accept="image/jpeg,image/png" class="form-control-file" :disabled="ocupada" @change="elegirArchivo" />
                </div>
                <div class="campo-nombre">
                    <label for="nombre-escaneo">Nombre del registro</label>
                    <input id="nombre-escaneo" v-model="nombre" class="form-control" maxlength="150" placeholder="Ej. Ensayo septiembre" :disabled="ocupada" />
                </div>
                <button class="btn btn-primary" type="submit" :disabled="!archivo || ocupada">
                    <i class="bx bx-upload mr-1" aria-hidden="true"></i>{{ guardando ? 'Guardando ' + progreso + '%' : 'Subir imagen' }}
                </button>
            </form>
            <div class="estado-motor" :class="{ disponible: azureDisponible }">
                <i :class="azureDisponible ? 'bx bx-check-circle' : 'bx bx-time-five'" aria-hidden="true"></i>
                {{ azureDisponible ? 'Azure Layout configurado' : (perfil.azure ? perfil.azure.mensaje : 'Comprobando Azure...') }}
                <span>Comparacion de pauta · revision humana</span>
            </div>
            <div class="mesa">
                <aside class="historial">
                    <div class="section-heading"><h2>Mis escaneos <small>{{ registros.length }}</small></h2>
                        <button class="btn btn-light btn-icon" title="Actualizar historial" aria-label="Actualizar historial" :disabled="cargando || ocupada" @click="cargar"><i class="bx bx-refresh"></i></button>
                    </div>
                    <label class="sr-only" for="buscar-escaneo">Buscar escaneo</label>
                    <input id="buscar-escaneo" v-model="busqueda" class="form-control mb-2" type="search" placeholder="Nombre, RUT o prueba (M1)" />
                    <label class="sr-only" for="estado-escaneo">Estado</label>
                    <select id="estado-escaneo" v-model="filtro" class="form-control mb-3">
                        <option value="">Todos los estados</option>
                        <option value="comparada">Lectura comparada</option>
                        <option value="leida">Leida sin pauta compatible</option>
                        <option value="pendiente_calibracion">Pendiente de lectura</option>
                        <option value="procesando">Leyendo</option>
                        <option value="pendiente_alineacion">Pendiente de alineacion</option>
                        <option value="piloto_pendiente_revision">Pendiente de revision</option>
                        <option value="rechazada_calidad">Calidad insuficiente</option>
                        <option value="error">Error de lectura</option>
                    </select>
                    <p v-if="cargando" role="status" class="text-muted">Cargando historial...</p>
                    <p v-else-if="!filtrados.length" class="text-muted">{{ registros.length ? 'Sin coincidencias.' : 'Aun no hay escaneos.' }}</p>
                    <div class="lista-registros">
                        <button v-for="registro in filtrados" :key="registro.id" class="registro" :class="{ activo: seleccionado && registro.id === seleccionado.id }"
                            :disabled="ocupada" :aria-pressed="!!(seleccionado && registro.id === seleccionado.id)" @click="abrir(registro)">
                            <strong>{{ registro.nombre }}</strong><time>{{ fecha(registro.creado_en) }}</time>
                            <span class="estado-registro" :class="estadoRegistro(registro)">{{ etiquetaEstadoRegistro(registro) }}</span>
                            <template v-if="registro.resumen_lectura">
                                <span v-if="registro.resumen_lectura.tipo_prueba" class="prueba-registro">
                                    {{ registro.resumen_lectura.tipo_prueba }} · {{ registro.resumen_lectura.cantidad_preguntas }} preguntas
                                    <span v-if="registro.resumen_lectura.referencial">(referencial)</span>
                                </span>
                                <span class="rut-registro">RUT: {{ registro.resumen_lectura.rut || registro.resumen_lectura.rut_tentativo || 'Sin lectura segura' }}
                                    <small v-if="!registro.resumen_lectura.rut && registro.resumen_lectura.rut_tentativo"> · Tentativo, requiere revisión</small></span>
                                <span v-if="registro.resumen_lectura.porcentajes" class="porcentajes-registro">
                                    <span class="aciertos-registro">{{ porcentaje(registro.resumen_lectura.porcentajes.correctas) }} acierto ({{ registro.resumen_lectura.totales.correctas }})</span>
                                    <span class="errores-registro">{{ porcentaje(registro.resumen_lectura.porcentajes.incorrectas) }} error ({{ registro.resumen_lectura.totales.incorrectas }})</span>
                                    <span>{{ porcentaje(registro.resumen_lectura.porcentajes.omitidas) }} omitidas ({{ registro.resumen_lectura.totales.omitidas }})</span>
                                    <span>{{ porcentaje(registro.resumen_lectura.porcentajes.por_revisar) }} por revisar / no válidas ({{ registro.resumen_lectura.totales.por_revisar }})</span>
                                </span>
                            </template>
                            <span v-else-if="registro.resumen" class="text-muted">{{ registro.resumen.valida || 0 }} / 80 aceptadas</span>
                        </button>
                    </div>
                </aside>
                <main class="detalle">
                    <div v-if="cargandoDetalle" class="vacio" role="status">Cargando registro...</div>
                    <div v-else-if="!seleccionado && !previa" class="vacio"><i class="bx bx-scan" aria-hidden="true"></i><h2>Sin documento seleccionado</h2></div>
                    <template v-else>
                        <div class="section-heading detalle-heading">
                            <div><h2>{{ seleccionado ? seleccionado.nombre : archivo.name }}</h2>
                                <span class="text-muted">{{ seleccionado ? estado(seleccionado.estado_azure || seleccionado.estado) : 'Sin guardar' }}</span></div>
                            <div v-if="seleccionado" class="acciones">
                                <a :href="imagenUrl" class="btn btn-light btn-icon" target="_blank" rel="noopener" title="Abrir imagen original" aria-label="Abrir imagen original"><i class="bx bx-expand"></i></a>
                                <a :href="'/api/escaneos-respuestas/' + seleccionado.id + '/json'" class="btn btn-outline-primary"><i class="bx bx-download mr-1"></i>JSON</a>
                            </div>
                        </div>
                        <div class="documento-resultados" :class="{ 'resumen-azure': resultadoAzure }">
                        <section v-if="respuestasNumeradasAzure.length" class="respuestas-numeradas-azure">
                            <div class="section-heading"><h3>Respuestas 1-{{ limitePreguntasAzure }}</h3>
                                <span>{{ letrasDetectadasAzure }} con letra · {{ respuestasVisiblesAzure.length - letrasDetectadasAzure }} por revisar</span></div>
                            <div v-if="comparacionPautaAzure && ['comparada', 'comparada_referencial'].includes(comparacionPautaAzure.estado)" class="resumen-pauta-azure" role="status">
                                <strong>{{ comparacionPautaAzure.nombre }}{{ comparacionPautaAzure.estado === 'comparada_referencial' ? ' · referencial' : '' }} · {{ comparacionPautaAzure.cantidad_preguntas }} preguntas</strong>
                                <small v-if="comparacionPautaAzure.estado === 'comparada_referencial'">No se identificó la asignatura; se compara con M1 solo como referencia.</small>
                                <span>{{ comparacionPautaAzure.resumen.correctas }} correctas · {{ comparacionPautaAzure.resumen.incorrectas }} incorrectas ·
                                    {{ comparacionPautaAzure.resumen.omitidas }} omitidas · {{ comparacionPautaAzure.resumen.por_revisar }} por revisar</span>
                            </div>
                            <p v-else-if="comparacionPautaAzure && comparacionPautaAzure.estado === 'asignatura_no_corresponde'" class="aviso-pauta-azure">
                                {{ comparacionPautaAzure.estado === 'asignatura_no_corresponde'
                                    ? 'No se aplicó la pauta M1: la asignatura leída no corresponde a Matemáticas.'
                                    : 'No se aplicó la pauta M1: no se pudo identificar la asignatura en los datos escritos.' }}
                            </p>
                            <div v-if="comparacionProveedor" class="alert" :class="comparacionProveedor.alumno ? 'alert-info' : 'alert-warning'">
                                <template v-if="comparacionProveedor.alumno">
                                    Proveedor: {{ comparacionProveedor.alumno.nombre }} · {{ comparacionProveedor.alumno.rut }} · {{ comparacionProveedor.alumno.actividad }}.
                                    {{ comparacionProveedor.estado === 'asociada_aproximada' ?
                                        `Asociación aproximada · ${comparacionProveedor.similitud.toFixed(1)}% de similitud del RUT · identidad por revisar.` :
                                        (comparacionProveedor.estado === 'asociada_manualmente' ? 'Identidad confirmada manualmente.' : 'Asociación por RUT seguro.') }}
                                    {{ comparacionProveedor.resumen.coincide }} coinciden,
                                    {{ comparacionProveedor.resumen.difiere }} difieren,
                                    {{ comparacionProveedor.resumen.sin_lectura }} sin lectura segura.
                                    Comparación entre lectores, no calificación.
                                </template>
                                <template v-else>Proveedor pendiente de asociación:
                                    {{ comparacionProveedor.motivo === 'rut_no_encontrado' ? 'el RUT no figura en el informe.' : 'el RUT requiere revisión; no se asociaron respuestas.' }}
                                </template>
                            </div>
                            <div class="bloques-respuestas-azure" :class="{ 'con-proveedor': comparacionProveedor }">
                                <div v-for="bloque in bloquesRespuestasAzure" :key="bloque.inicio" class="bloque-respuestas-azure">
                                <table class="table table-sm">
                                    <caption class="sr-only">Respuestas {{ bloque.inicio }}-{{ bloque.fin }}</caption>
                                    <thead><tr><th scope="col">N.</th><th scope="col">Letra</th><th v-if="comparacionProveedor" scope="col" class="columna-proveedor">Proveedor</th><th scope="col" class="rango-respuestas-azure">{{ bloque.inicio }}-{{ bloque.fin }}<span class="sr-only"> · Revision</span></th></tr></thead>
                                    <tbody><tr v-for="respuesta in bloque.respuestas" :key="respuesta.pregunta" :class="{
                                        'inicio-segmento': respuesta.pregunta === bloque.inicio + 10,
                                        'respuesta-pendiente': respuesta.estado !== 'detectada',
                                        'respuesta-calificada-correcta': respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'correcta',
                                        'respuesta-calificada-incorrecta': respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'incorrecta',
                                        'respuesta-calificada-omitida': respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'omitida',
                                        'respuesta-calificada-revision': respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'por_revisar'
                                    }">
                                        <th scope="row">{{ respuesta.pregunta }}</th>
                                        <td :title="motivo(respuesta.motivo) || estado(respuesta.estado)"><strong>{{ respuesta.alternativa || '-' }}</strong>
                                            <small v-if="respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'incorrecta'" class="respuesta-clave">Clave: {{ respuesta.evaluacion_pauta.alternativa_correcta }}</small>
                                            <small v-else-if="respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'omitida'" class="respuesta-clave">Omitida</small>
                                            <small v-else-if="respuesta.evaluacion_pauta && respuesta.evaluacion_pauta.estado === 'por_revisar'" class="respuesta-clave">Revisar</small>
                                            <span v-if="respuesta.estado !== 'detectada'" class="sr-only">{{ respuesta.estado === 'en_blanco' ? 'En blanco' : 'Revisar' }}</span></td>
                                        <td v-if="comparacionProveedor" :class="{ 'text-danger': respuestasProveedor[respuesta.pregunta] && respuestasProveedor[respuesta.pregunta].estado === 'difiere' }">
                                            <template v-if="respuestasProveedor[respuesta.pregunta]">
                                                <strong>{{ respuestasProveedor[respuesta.pregunta].alternativa || 'Omitida' }}</strong>
                                                <small class="respuesta-clave">{{ estado(respuestasProveedor[respuesta.pregunta].estado) }}</small>
                                            </template>
                                            <span v-else>Sin asociar</span>
                                        </td>
                                        <td><button class="btn btn-light btn-icon" :title="'Revisar pregunta ' + respuesta.pregunta + ': ' + (motivo(respuesta.motivo) || estado(respuesta.estado))"
                                            :aria-label="'Revisar pregunta ' + respuesta.pregunta" :disabled="!respuesta.detecciones.length" @click="enfocarRespuestaAzure(respuesta)"><i class="bx bx-target-lock" aria-hidden="true"></i></button></td>
                                    </tr></tbody>
                                </table>
                                </div>
                            </div>
                        </section>
                            <div class="documento">
                                <div class="section-heading"><h3>Imagen original</h3>
                                    <label v-if="resultadoAzure" class="control-marcas"><input v-model="mostrarMarcasAzure" type="checkbox" /> Marcas detectadas</label></div>
                                <div class="imagen-interactiva">
                                    <img :key="imagenUrl" :src="imagenUrl" alt="Hoja de respuestas original" @load="dimensiones = [$event.target.naturalWidth, $event.target.naturalHeight]" />
                                    <template v-if="mostrarMarcasAzure">
                                        <span v-for="marca in marcasPosicionadasAzure" :key="'azure-' + marca.deteccion" class="marca-azure" :class="{ seleccionada: marca.estado === 'selected', dudosa: marca.confianza < 0.8 || marca.confianza == null, enfocada: marca.deteccion === deteccionAzure }" :style="marca.posicion" aria-hidden="true"></span>
                                    </template>
                                </div>
                                <div v-if="marcaActivaAzure" ref="detalleMarcaAzure" class="detalle-marca" aria-live="polite">
                                    <h3>Detalle de respuesta</h3>
                                    <svg class="recorte-azure" :viewBox="recorteAzure" role="img" :aria-label="'Ampliacion de deteccion ' + marcaActivaAzure.deteccion">
                                        <image :href="imagenUrl" :width="paginaAzure.width" :height="paginaAzure.height" />
                                        <polygon :points="marcaActivaAzure.poligono.join(' ')" fill="none" stroke="#1266ad" stroke-width="1" />
                                    </svg>
                                </div>
                            </div>
                            <div class="lectura">
                                <p v-if="!seleccionado" class="text-muted">Imagen pendiente de guardar.</p>
                                <template v-else>
                                    <template v-if="!resultadoAzure">
                                        <h3>Lectura Azure Layout</h3>
                                        <p v-if="!azureDisponible" class="alert alert-warning">{{ perfil.azure && perfil.azure.mensaje }}</p>
                                        <p v-if="seleccionado.estado_azure === 'error' && seleccionado.mensaje_azure" class="alert alert-warning">{{ seleccionado.mensaje_azure }}</p>
                                        <p v-if="seleccionado.estado_azure === 'procesando' || leyendoAzure" role="status">Lectura Azure en curso...</p>
                                        <label class="autorizacion-azure"><input v-model="autorizarAzure" type="checkbox" :disabled="!azureDisponible || ocupada" /> Autorizar envio de esta imagen a Azure</label>
                                        <button class="btn btn-primary" :disabled="!puedeLeerAzure" @click="leerAzure"><i class="bx bx-cloud-upload mr-1"></i>{{ leyendoAzure ? 'Leyendo...' : 'Leer con Azure' }}</button>
                                    </template>
                                    <template v-else>
                                        <div class="section-heading"><h3>Datos escritos</h3><span class="text-muted estado-cabecera">OCR · Sin verificar</span></div>
                                        <dl class="campos-escritos">
                                            <div v-for="campo in camposEscritosAzure" :key="campo.id">
                                                <dt>{{ campo.etiqueta }}</dt><dd>{{ campo.valor || (campo.id === 'rut' ? 'Sin lectura segura' : 'Sin lectura') }}
                                                    <small v-if="campo.id === 'rut' && campo.rutVerificacion && !campo.rutVerificacion.valor_rut && campo.rutVerificacion.valor_tentativo">
                                                        Lectura tentativa, no confirmada. «?» indica un dígito no determinado.
                                                    </small>
                                                    <small v-if="campo.id === 'rut' && campo.rutVerificacion" :class="'rut-' + campo.rutVerificacion.estado">
                                                        {{ estadoRutAzure(campo.rutVerificacion.estado) }}
                                                        <span v-if="motivoRutAzure(campo.rutVerificacion.motivo)"> · {{ motivoRutAzure(campo.rutVerificacion.motivo) }}</span>
                                                        <span v-if="!campo.valor && campo.rutVerificacion.valor_burbujeado"> · Lectura parcial: {{ campo.rutVerificacion.valor_burbujeado }}</span>
                                                    </small>
                                                    <small v-if="campo.id === 'rut'">Manuscrito (OCR): {{ campo.escrito || 'Sin lectura' }}</small>
                                                    <small v-for="columna in (campo.rutVerificacion ? campo.rutVerificacion.columnas : [])" v-if="columna.motivo" :key="columna.columna">
                                                        Columna {{ columna.columna }}: {{ motivoRutAzure(columna.motivo) }}
                                                    </small>
                                                </dd>
                                            </div>
                                        </dl>
                                        <form v-if="alumnosProveedor.length" class="relectura-azure" @submit.prevent="asociarProveedor">
                                            <h3>Asociar con alumno del proveedor</h3>
                                            <label for="alumno-proveedor">Alumno del Excel</label>
                                            <select id="alumno-proveedor" v-model="rutProveedor" class="form-control mb-2" :disabled="ocupada" @change="confirmarProveedor = false">
                                                <option value="">Selecciona después de revisar la imagen</option>
                                                <option v-for="alumno in alumnosProveedor" :key="alumno.rut" :value="alumno.rut">
                                                    {{ alumno.nombre }} · {{ alumno.rut }} · {{ alumno.curso }}
                                                </option>
                                            </select>
                                            <label><input v-model="confirmarProveedor" type="checkbox" :disabled="ocupada || !rutProveedor" />
                                                Revisé el RUT en la imagen y confirmo que corresponde a este alumno.</label>
                                            <p>Se registra tu confirmación sin modificar el OCR ni las respuestas leídas. Una corrección conserva la asociación anterior.</p>
                                            <button class="btn btn-outline-primary" :disabled="ocupada || !rutProveedor || !confirmarProveedor">
                                                {{ asociandoProveedor ? 'Guardando...' : 'Confirmar asociación' }}
                                            </button>
                                        </form>
                                        <div class="relectura-azure">
                                            <label><input v-model="autorizarAzure" type="checkbox" :disabled="!azureDisponible || ocupada" />
                                                Confirmo una nueva lectura de pago de esta hoja (~US$0,01).</label>
                                            <p>La lectura actual se conserva en el historial si la nueva lectura termina correctamente.</p>
                                            <button class="btn btn-outline-primary" :disabled="!puedeReleerAzure" @click="releerAzure">
                                                <i class="bx bx-refresh mr-1"></i>{{ leyendoAzure ? 'Releyendo...' : 'Releer con Azure' }}
                                            </button>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </template>
                </main>
            </div>
            </div>
        </section>
    </Layout>
</template>

<style scoped>
.escaner { --linea: #dce3e8; --verde: #206b53; --ambar: #95620c; color: #35434e; letter-spacing: 0; }
.carga { display: flex; flex-wrap: wrap; gap: 20px; align-items: flex-end; padding: 18px 0 22px; border-bottom: 1px solid var(--linea); }
.carga label { display: block; font-weight: 600; }
.carga label span { font-weight: 400; font-size: 12px; margin-left: 8px; }
.campo-archivo { flex: 1 1 280px; min-width: 0; }
.campo-archivo input { width: 100%; }
.campo-nombre { flex: 1 1 220px; min-width: 0; }
.estado-motor { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; padding: 12px 0; color: var(--ambar); border-bottom: 1px solid var(--linea); }
.estado-motor.disponible { color: var(--verde); }
.estado-motor > span { margin-left: auto; color: #65737d; font-size: 12px; }
.mesa { display: grid; grid-template-columns: 260px minmax(0, 1fr); min-height: 600px; }
.historial { padding: 20px 18px 20px 0; border-right: 1px solid var(--linea); min-width: 0; }
.section-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; min-width: 0; }
.escaner h2 { font-size: 17px; margin: 0; overflow-wrap: anywhere; }
.escaner h2 small { color: #65737d; padding-left: 8px; }
.escaner h3 { font-size: 14px; margin: 0 0 12px; font-weight: 600; }
.section-heading h3 { margin: 0; }
.btn-icon { width: 36px; height: 36px; flex: 0 0 36px; padding: 7px; font-size: 18px; line-height: 20px; }
.acciones { display: flex; gap: 6px; align-items: center; flex-shrink: 0; }
.lista-registros { max-height: 750px; overflow-y: auto; }
.registro { display: flex; flex-direction: column; gap: 5px; width: 100%; text-align: left; border: 0; border-bottom: 1px solid var(--linea); border-left: 3px solid transparent; background: transparent; padding: 14px 10px; font-size: 12px; color: inherit; }
.registro strong { font-size: 14px; overflow-wrap: anywhere; }
.registro time { color: #65737d; }
.registro:hover { background: #edf2f5; }
.registro.activo { border-left-color: var(--verde); background: #edf5f1; }
.estado-registro { color: var(--ambar); }
.estado-registro.error, .estado-registro.rechazada_calidad { color: #aa3434; }
.estado-registro.comparada, .estado-registro.leida, .aciertos-registro { color: var(--verde); }
.prueba-registro { font-weight: 600; }
.rut-registro { overflow-wrap: anywhere; }
.porcentajes-registro { display: flex; flex-direction: column; gap: 3px; color: var(--ambar); }
.errores-registro { color: #aa3434; }
.detalle { min-width: 0; padding: 22px 0 22px 22px; }
.detalle-heading { min-height: 44px; }
.detalle-heading > div:first-child { min-width: 0; }
.nav-tabs { flex-wrap: wrap; gap: 0; }
.nav-tabs .nav-link { background: transparent; }
.nav-tabs .nav-link.active { background: #fff; }
.documento-resultados { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr); gap: 22px; }
.documento, .lectura { min-width: 0; }
.resumen-azure { grid-template-columns: minmax(0, 1fr) minmax(350px, 1.05fr); grid-template-areas: "imagen respuestas" "imagen datos"; align-items: start; gap: 18px; }
.resumen-azure > .documento { grid-area: imagen; }
.resumen-azure > .respuestas-numeradas-azure { grid-area: respuestas; }
.resumen-azure > .lectura { grid-area: datos; }
.respuestas-numeradas-azure { min-width: 0; margin: 0; container-type: inline-size; }
.respuestas-numeradas-azure .section-heading { flex-wrap: wrap; font-size: 12px; }
.resumen-pauta-azure { display: flex; flex-wrap: wrap; gap: 4px 12px; margin: -4px 0 12px; padding: 8px 10px; background: #edf5f1; border-left: 3px solid var(--verde); font-size: 11px; }
.resumen-pauta-azure strong, .resumen-pauta-azure small { flex-basis: 100%; }
.resumen-pauta-azure small, .aviso-pauta-azure { color: #65737d; font-size: 11px; margin-bottom: 10px; }
.bloques-respuestas-azure { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 8px; align-items: start; }
.bloque-respuestas-azure { min-width: 0; }
.bloques-respuestas-azure table { width: 100%; table-layout: fixed; margin: 0; font-size: 11px; font-variant-numeric: tabular-nums; border-collapse: separate; border-spacing: 0; }
.bloques-respuestas-azure th, .bloques-respuestas-azure td { vertical-align: middle; overflow-wrap: anywhere; padding: 1px 2px; }
.bloques-respuestas-azure thead th { height: 28px; white-space: nowrap; }
.bloques-respuestas-azure thead th:first-child { width: 28px; }
.bloques-respuestas-azure thead th:last-child { width: 46px; text-align: right; }
.bloques-respuestas-azure .columna-proveedor { width: 68px; }
.bloques-respuestas-azure tbody td:last-child { text-align: right; }
.bloques-respuestas-azure tbody tr { height: 44px; }
.bloques-respuestas-azure tbody tr > * { border-top: 1px solid rgba(50, 65, 72, 0.12); }
.bloques-respuestas-azure tbody tr:first-child > * { border-top: 0; }
.bloques-respuestas-azure td strong { font-size: 12px; }
.bloques-respuestas-azure .btn-icon { width: 24px; height: 24px; padding: 2px; font-size: 14px; line-height: 18px; border: 0; }
.bloques-respuestas-azure .inicio-segmento > * { border-top: 3px solid #9aa9b3; }
.respuesta-pendiente { background: #fff6dc; }
.respuesta-calificada-correcta > * { background: #e6f4ea !important; color: #206b53; }
.respuesta-calificada-incorrecta > * { background: #fde8e7 !important; color: #a12622; }
.respuesta-calificada-omitida > * { background: #fff2cc !important; color: #805b00; }
.respuesta-calificada-revision > * { background: #fff6dc !important; color: #805b00; }
.respuesta-clave { display: block; font-size: 9px; line-height: 1.1; }
@container (max-width: 599px) { .bloques-respuestas-azure { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@container (max-width: 299px) { .bloques-respuestas-azure { grid-template-columns: minmax(0, 1fr); } }
@container (max-width: 799px) { .bloques-respuestas-azure.con-proveedor { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@container (max-width: 399px) { .bloques-respuestas-azure.con-proveedor { grid-template-columns: minmax(0, 1fr); } }
.estado-cabecera { font-size: 11px; }
.relectura-azure { margin-top: 16px; padding-top: 12px; border-top: 1px solid var(--linea); font-size: 12px; }
.relectura-azure label { display: block; }
.relectura-azure p { color: #65737d; margin-bottom: 10px; }
.campos-escritos { margin: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 16px; }
.campos-escritos > div { min-width: 0; border-bottom: 1px solid var(--linea); padding-bottom: 6px; }
.campos-escritos dt { font-size: 11px; color: #65737d; font-weight: 500; }
.campos-escritos dd { font-size: 13px; line-height: 1.4; overflow-wrap: anywhere; margin: 2px 0 0; }
.campos-escritos small { display: block; color: var(--ambar); font-size: 11px; }
.campos-escritos .rut-coincide { color: var(--verde); }
.campos-escritos .rut-difiere { color: #aa3434; }
.campos-escritos .rut-pendiente_revision { color: var(--ambar); }
@media (min-width: 1700px) { .resumen-azure { grid-template-columns: minmax(0, 1fr) minmax(350px, 1fr) minmax(220px, 0.75fr); grid-template-areas: "imagen respuestas datos"; } .campos-escritos { grid-template-columns: minmax(0, 1fr); } }
.imagen-interactiva { position: relative; width: 100%; line-height: 0; }
.imagen-interactiva img { width: 100%; height: auto; display: block; border: 1px solid var(--linea); }
.imagen-interactiva.alineando { cursor: crosshair; }
.marca-azure { position: absolute; border: 1px solid #68747c; pointer-events: none; box-sizing: border-box; }
.marca-azure.seleccionada { border: 2px solid var(--verde); background: rgba(32, 107, 83, 0.12); }
.marca-azure.dudosa { border-color: var(--ambar); border-style: dashed; }
.marca-azure.enfocada { border: 2px solid #1266ad; outline: 2px solid #fff; z-index: 1; }
.control-marcas { margin: 0; font-size: 12px; }
.detalle-marca { margin-top: 16px; }
.recorte-azure { display: block; width: 100%; height: 160px; background: #f0f3f5; }
.tabla-azure { max-height: 450px; }
.fila-enfocada { background: #e4f1fa; }
.marcador { position: absolute; transform: translate(-50%, -50%); width: 22px; height: 22px; border-radius: 50%; background: #a82233; border: 2px solid #fff; color: #fff; font-size: 11px; font-weight: 700; line-height: 18px; text-align: center; pointer-events: none; }
.marcador.siguiente { background: #195e45; outline: 3px solid #77bfa5; }
.contadores { display: flex; flex-wrap: wrap; gap: 12px 20px; padding: 14px 0; border-top: 1px solid var(--linea); border-bottom: 1px solid var(--linea); }
.contadores span { font-size: 12px; color: #65737d; }
.contadores strong { display: block; font-size: 23px; color: #35434e; }
.tabla-scroll { max-height: 680px; overflow: auto; margin-top: 14px; }
.tabla-scroll table { font-size: 12px; margin: 0; }
.tabla-scroll th { position: sticky; top: 0; background: #eef2f5; z-index: 1; }
.tabla-scroll td { vertical-align: middle; padding: 9px 6px; }
.respuesta-valida, .respuesta-coincide { color: var(--verde); }
.respuesta-ambigua, .respuesta-difiere { color: var(--ambar); }
.respuesta-ilegible, .respuesta-sin_lectura { color: #aa3434; }
.datos-cabecera { padding: 14px 0 0; font-size: 12px; }
.datos-cabecera summary { cursor: pointer; }
.datos-cabecera span { display: block; margin-top: 5px; }
.datos-cabecera dl { margin-top: 12px; overflow-wrap: anywhere; }
.autorizacion-azure { display: block; margin: 18px 0; }
.filtros-azure { display: flex; flex-wrap: wrap; gap: 8px 16px; margin-top: 14px; }
.filtros-azure label { margin: 0; }
.texto-azure { white-space: pre-wrap; overflow-wrap: anywhere; max-height: 560px; overflow-y: auto; background: #f0f3f5; padding: 14px; font-size: 12px; }
.json-view { background: #f0f3f5; padding: 16px; }
.json-view pre { max-height: 800px; font-size: 12px; margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
.vacio { min-height: 350px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 15px; color: #65737d; }
.vacio > i { font-size: 44px; }
@media (max-width: 1199px) { .mesa { grid-template-columns: 220px minmax(0, 1fr); } .documento-resultados { grid-template-columns: minmax(0, 1fr); } .documento { max-width: 650px; } }
@media (max-width: 1199px) { .resumen-azure { grid-template-areas: "respuestas" "datos" "imagen"; } }
@media (max-width: 575px) { .campos-escritos { grid-template-columns: minmax(0, 1fr); } }
@media (max-width: 767px) { .mesa { grid-template-columns: minmax(0, 1fr); } .historial { border-right: 0; border-bottom: 1px solid var(--linea); padding-right: 0; } .lista-registros { max-height: 240px; } .detalle { padding-left: 0; } .estado-motor > span { margin-left: 0; width: 100%; } .detalle-heading { flex-wrap: wrap; } .carga .btn { width: 100%; } }
</style>
